import { Component, Input } from '@angular/core';

@Component({
	selector: 'nm-page-header',
	templateUrl: './page-header.html',
	styleUrls: ['./page-header.css']
})
export class NmPageHeader {

	@Input() header: string;

	public constructor() {}

}


// WEBPACK FOOTER //
// ./src/widgets/page-header/page-header.ts